import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { Store } from '@ngxs/store';

import { ProfileState } from '@client/app/profile/state/profile.state';
import { TutorialsService } from '@client/app/shared/services/tutorials.service';

import { RouterLinkCreatorService } from '../../../../services/router-link-creator.service';
import { MainNavItemsService } from '../../services/main-nav-items.service';
import { MainNavService } from '../../services/main-nav.service';

@Component({
  selector: 'sh-main-nav-platform-items-for-user-mobile',
  templateUrl: './main-nav-platform-items-for-user-mobile.component.html',
  styleUrl: './main-nav-platform-items-for-user-mobile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MainNavPlatformItemsForUserMobileComponent {
  readonly mainNavItemsService = inject(MainNavItemsService);
  readonly mainNavService = inject(MainNavService);
  readonly #routerLinkCreatorService = inject(RouterLinkCreatorService);
  readonly #tutorialsService = inject(TutorialsService);
  readonly #store = inject(Store);

  @Output() closeMenu = new EventEmitter();

  profilesOpen$ = new BehaviorSubject(false);
  isSuperAdmin$ = this.mainNavService.isSuperAdmin$;

  knowledgeBaseURL = this.#tutorialsService.getKnowledgeBaseUrl();
  loadedProfileSubscription$ = this.#store.select(ProfileState.getProfileActiveSubscription);

  openProfiles() {
    this.profilesOpen$.next(true);
  }

  closeProfiles() {
    this.profilesOpen$.next(false);
  }

  createProfile() {
    this.#routerLinkCreatorService.navigateToCreateProfile();
  }

  onCloseMenu() {
    this.closeMenu.emit();
  }

  onBecameEsgProBtnClick(profileId: number, subscriptionType: string): void {
    this.#tutorialsService.trackEventClickOnTutorials(profileId, subscriptionType);
  }
}
